import { Injectable } from '@angular/core';

@Injectable({
   providedIn: 'root',
})
export class SessionStorageService {
   constructor() {}

   setSearchCustomFilters(value: any) {
      sessionStorage.setItem('sSearch_CustomFilters', value);
   }

   getSearchCustomFilters() {
      sessionStorage.getItem('sSearch_CustomFilters');
   }

   removeSearchCustomFilters() {
      sessionStorage.removeItem('sSearch_CustomFilters');
   }

   removeSearchPageIndex() {
      sessionStorage.removeItem('sSearch_PageIndex');
   }

   removeSearchPageLength() {
      sessionStorage.removeItem('sSearch_PageLength');
   }

   removeSearchAll() {
      for (let i = 0; i < 10; i++) {
         sessionStorage.removeItem('sSearch_' + i);
      }
   }
}
